export default __webpack_public_path__ + "static/media/Starboy.1492bf67.mp3";